const MAX_ATTEMPTS = 6;
const BACKOFFS = [1000, 2000, 4000, 8000, 16000, 30000];

/**
 * Executes a Firestore write operation with exponential backoff and jitter.
 * Retries specifically on resource exhaustion or timeouts.
 */
export async function writeWithBackoff(operation: () => Promise<void>): Promise<boolean> {
  for (let i = 0; i < MAX_ATTEMPTS; i++) {
    try {
      await operation();
      return true;
    } catch (err: any) {
      const isRetriable = 
        err.message?.includes('resource-exhausted') || 
        err.message?.includes('deadline-exceeded') || 
        err.message?.includes('unavailable') || 
        err.code === 'resource-exhausted' ||
        err.code === 'deadline-exceeded' ||
        err.code === 'unavailable' ||
        err.code === 'aborted';
        
      if (!isRetriable || i === MAX_ATTEMPTS - 1) {
        console.error("[Firestore Backoff] Operation failed permanently:", err);
        return false;
      }
      
      const delay = BACKOFFS[i] + Math.random() * 500; // Add jitter
      if (import.meta.env.VITE_DEBUG_FIRESTORE === 'true') {
         console.warn(`[Firestore Backoff] Attempt ${i+1} failed. Retrying in ${Math.round(delay)}ms... code: ${err.code}`);
      }
      await new Promise(res => setTimeout(res, delay));
    }
  }
  return false;
}
